import { useContext } from "react"
import { FormProvider, useForm } from "react-hook-form"
import SeoContainer from "~/components/Seo/SeoContainer"
import UnsavedChanges from "~/components/Seo/UnsavedChanges"
import { SEO_SCHEMA } from "~/constants/seo"
import CourseContext from "~/contexts/Course"
import useSetSeoMutation from "~/hooks/useSetSeoMutation"
import useYupValidationResolver from "~/hooks/useYupValidationResolver"

const seoSchema = SEO_SCHEMA

const Seo = () => {
  const { course } = useContext(CourseContext)
  const { mutateAsync, isLoading } = useSetSeoMutation({
    type: "course",
    type_id: course.id,
  })

  const onSubmitHandler = async (data) => {
    await mutateAsync(data).then((res) => {
      methods.reset({
        title: res.title ?? "",
        description: res.description ?? "",
        image: res.image ?? "",
      })
    })
  }

  const resolver = useYupValidationResolver(seoSchema)
  const methods = useForm({
    resolver,
    defaultValues: {
      title: course?.seo?.title || "",
      description: course?.seo?.description || "",
      image: course?.seo?.image || {},
    },
  })

  return (
    <FormProvider {...methods}>
      <SeoContainer onSubmitHandler={methods.handleSubmit(onSubmitHandler)} />
      <UnsavedChanges
        onSubmitHandler={methods.handleSubmit(onSubmitHandler)}
        isLoading={isLoading ?? false}
      />
    </FormProvider>
  )
}

export default Seo
